import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import "./DocumentRules.scss";

import {
    Button,
    Table,
    Form,
    Badge,
    Modal,
    Breadcrumb,
    Tooltip,
    OverlayTrigger,
} from "react-bootstrap";
import { BiPlus, BiTrash, BiChevronDown, BiPencil } from "react-icons/bi";
import { FcFolder, FcFile } from "react-icons/fc";
import DocumentRuleService from "../../../core/service/DocumentRuleService";
import { toast } from "react-toastify";
import ConfirmDialog from '../../../core/utilities/ConfirmPopup';
import Utils from "../../../core/utilities/Utils";
import { BsQuestionCircle } from "react-icons/bs";


function DocumentRules({ t }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { reg_id } = useParams();
    const navigate = useNavigate();
    const [ruleslist, setRulesList] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteid, setDeleteId] = useState('');
    useEffect(() => {
        getRules()
    }, []);
    const getRules = () => {
        DocumentRuleService.getList(reg_id)
            .then((response) => {
                setRulesList([...response.data]);
            })
            .catch((error) => {
                console.log("err", error);
            });
    };

    const createRule = () => {
        navigate("/company_admin/document_rules_create/" + reg_id);
    };

    const deletConfirm = () => {
        DocumentRuleService.deleteData(reg_id, deleteid)
            .then((response) => {
                if (response.status === 200 || response.status === 201 || response.status === 204) {
                    toast.success('Success', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    getRules();
                }
            })
            .catch((error) => {
                console.log('error', error);
                toast.error(error.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const editData = (id) => {
        navigate("/company_admin/document_rules_edit/" + reg_id + '/' + id);
    };

    const goBack = () => {
        navigate("/company_admin/configurations");
    }
    const RulesDocScanHelpText = (
        <Tooltip id="Risk_help_test">
           {t("DefineRulesSelectedFoldersToolTip.label")}
        </Tooltip>
    );
    return (
        <div className="DocumentRules">
            <div className="List_header">
                <Breadcrumb className="h6">
                    <Breadcrumb.Item href="#" onClick={() => goBack()}>{t("Configurations.label")}</Breadcrumb.Item>
                    <Breadcrumb.Item href="#">
                        {t("DocumentScanRules.label")}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div>
                <div className="No_Docu_Rules">
                    <div>
                        <h5>{t("RulesDocScan.label")}
                            <OverlayTrigger
                                placement="bottom"
                                overlay={RulesDocScanHelpText}
                            >
                                <span className="ms-2  text-dark "><BsQuestionCircle /></span>
                            </OverlayTrigger>
                        </h5>
                    </div>
                    {ruleslist.length === 0 && <div className="mb-3">
                        <p>{t("NoDocRuleCreated.label")}</p>
                    </div>}
                </div>
                {ruleslist?.length > 0 && ruleslist?.map((item, index) => (<div className="card Add_Document_RulesCard mb-2">
                    <div className="card-body p-0">
                        <div className="Add_DR_ViewCard">
                            {/* <div className="expand_DR_Box">
                                <BiChevronDown />
                            </div> */}
                            <div className="row mx-0">
                                <div className="col-md-12 px-1">
                                    <h6>{item.name}</h6>
                                </div>
                                <div className="col-md-12 px-1 pb-2">
                                    <ul>
                                        {item.folders && item.folders.length > 0 && item.folders.map((folderItem, folderIndex) => (<li>
                                            <FcFolder />
                                            {folderItem.name}
                                        </li>))}
                                        <li className="Searchkeyword_View_viewcard">
                                            Search keyword :
                                            {item.keywords.length > 0 && item.keywords.map((keywordsItem, keywordsIndex) => (
                                                <b>{keywordsItem.searchText}</b>
                                            ))}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className='Add_DR_ViewCard_btn'>

                            <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Delete.label"))}>
                                <span className='cursor'><BiTrash onClick={() => {
                                    setDeleteId(item.id);
                                    setConfirmOpen(true);
                                }} /></span>
                            </OverlayTrigger>
                            <ConfirmDialog
                                title={t("confirmation.label")}
                                open={confirmOpen}
                                setOpen={setConfirmOpen}
                                onConfirm={deletConfirm}                        >
                                <div className='text-center'>{t("ConfirmDelete.label")}</div>
                            </ConfirmDialog>
                            <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
                                <span className='cursor'><BiPencil onClick={() => {
                                    editData(item.id);
                                }} /></span>
                            </OverlayTrigger>
                        </div>

                    </div>
                </div>))}

                <div className="mb-2">
                    <Button variant="primary" className="px-4 sbmBtn" onClick={() => createRule()}>New Rules</Button>
                </div>
            </div>

        </div >
    )
};
export default withTranslation()(DocumentRules);